(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    import('@theme/component').then(({ Component }) => {
  class MpQualityGuard extends Component {
    #controller;
    connectedCallback() {
      super.connectedCallback();
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.addEventListener('change', this.handleQualityChange, {capture: true, signal: this.#controller.signal});
    }
    disconnectedCallback() {
      this.#controller?.abort();
      super.disconnectedCallback();
    }
    handleQualityChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      const selectedOption = target instanceof HTMLSelectElement ? target.selectedOptions[0] : target;
      if (selectedOption?.dataset.optionName !== 'Qualité') return;
      const source = this.querySelector('[data-mp-quality-data]');
      if (!source) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch { return; }
      const picker = this.querySelector('variant-picker');
      if (!picker || typeof picker.getAllSelectedOptions !== 'function') return;
      const selection = Object.fromEntries(picker.getAllSelectedOptions().map(option => [option.name, option.value]));
      selection.Qualité = selectedOption.value;
      const exact = data.variants.find(variant => data.names.every((name, index) => variant.options[index] === selection[name]));
      if (exact) return;
      const qualityIndex = data.names.indexOf('Qualité');
      const sizeIndex = data.names.findIndex(name => ['Size', 'Taille'].includes(name));
      const candidates = data.variants.filter(variant => variant.available && variant.options[qualityIndex] === selection.Qualité);
      const fallback = candidates.find(variant => sizeIndex < 0 || variant.options[sizeIndex] === selection[data.names[sizeIndex]]) || candidates[0];
      if (!fallback) return;
      for (const [index, name] of data.names.entries()) {
        if (name === 'Qualité' || selection[name] === fallback.options[index]) continue;
        const radio = Array.from(picker.querySelectorAll('input[type="radio"]')).find(input => input.dataset.optionName === name && input.value === fallback.options[index]);
        if (radio) { picker.updateSelectedOption(radio); continue; }
        const select = Array.from(picker.querySelectorAll('select')).find(element => Array.from(element.options).some(option => option.dataset.optionName === name));
        if (select) { select.value = fallback.options[index]; picker.updateSelectedOption(select); }
      }
    };
  }
  if (!customElements.get('mp-quality-guard')) customElements.define('mp-quality-guard', MpQualityGuard);
});
  } catch(e) { console.error(e); }
})();

})();
